<div class="user-add-header">
  <h2 class="user-add-header__title">{{ getHeaderTitle() }}</h2>
  <span class="user-add-header__close material-icons" (click)="closeSideNav()"
    >close</span
  >
</div>

<main class="user-add-body">
  @if (currentStep === UserAddStep.SEARCH) {
    <pl-step-search
      [searchCloneableLogonForm]="searchCloneableLogonForm"
      [inputError]="inputError"
      [isTooManyResultsError]="isTooManyResultsError"
      [searchExecuted]="searchExecuted"
      [searchResultsLoading]="searchResultsLoading"
      [searchResults]="searchResults"
      [selectedLogon]="selectedLogon"
      [errorMessage]="errorMessage"
      [hasError]="hasError"
      (searchRequested)="onSearchRequested($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (clearSearchEvent)="clearSearch()"
      (searchCriteriaChanged)="onSearchCriteriaChanged()"
    ></pl-step-search>
  }

  @if (currentStep === UserAddStep.PRODUCTS) {
    <pl-step-products
      [cloneableLogon]="cloneableLogonData"
      [pmeLimitReached]="isPmeLimitReached()"
    ></pl-step-products>
  }

  @if (currentStep === UserAddStep.FORM) {
    <pl-step-form
      [entriesForm]="entriesForm"
      [cloneableLogon]="cloneableLogonData"
      [errorMessage]="errorMessage"
      [hasError]="hasError"
      [isLoading]="createLogonLoading"
      [pmeLogonsCount]="pmeLogonsCount"
      [pmeLimitsUnavailable]="pmeLimitsUnavailable"
      [pmeLimitReached]="isPmeLimitReached()"
      [failedCloneResults]="failedCloneResults"
    ></pl-step-form>
  }
</main>

<!-- Footer - 10% -->
<pl-action-footer>
  <div class="action-footer">
    <!-- Back button - only show if not on first step -->
    @if (canGoBack()) {
      <div
        class="action-footer__back"
        (click)="goBack()"
        launchLabel="Voltar"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
        <span class="material-icons">arrow_back_ios</span>
        <span>Voltar</span>
      </div>
    } @else {
      <div></div>
    }

    <!-- Next/Action button -->
    <seds-basic-button
      class="action-footer__next"
      type="button"
      [title]="getNextButtonTitle()"
      [disabled]="isNextButtonDisabled() || createLogonLoading"
      (click)="onNextButtonClick()"
      [loading]="createLogonLoading"
      launchLabel="{{ getNextButtonTitle() }}"
      launchSection="Clique"
      launchSiteSection="PortalDeLogons"
      plAnalyticsButton
    ></seds-basic-button>
  </div>
</pl-action-footer>
